<template>
  <div>
    <Top />
    <Oksana />
    <Portfolio />
    <Performances />
    <StudentsReview />
    <Ceremony />
    <Testimonials />     
    <Contact />       
  </div>
</template>

<script>
  import Top from '../components/Top'
  import Oksana from '../views/Oksana'
  import Portfolio from '../views/Portfolio'
  import Ceremony from '../views/Ceremony'
  import Testimonials from '../views/Testimonials'
  import StudentsReview from '../views/StudentsReviews'
  import Performances from '../views/Performances'  
  import Contact from '../views/Contact'
  export default {
    name: 'Home',
    components: {
      Top, Oksana, Portfolio, Ceremony, Testimonials, Performances, StudentsReview, Contact
    },
    mounted(){
      this.setLayout('app-layout')  
    },
    methods: {
      setLayout (layout) {
        this.$store.commit('setLayout', layout)
      }
    }
  }
</script>


